
import useFileTypeData from '../../../state/personNationalTeamFileType/UsePersonNationalTeamFileTypeData';

const useFileTypeDropdown = (isPublicFileType) => {
  const { personNationalTeamFileTypeState } = useFileTypeData();

  const arrayDataFiltered = personNationalTeamFileTypeState?.arrayData.filter(
            item => item.isPublicType === isPublicFileType ? 1 : 0).map(
              item => ({ id: item.personNationalAttachmentFileTypeId, name: item.typeName })) || []

  const arrayData = personNationalTeamFileTypeState.dataAsOptionsWithNames || [];
    

  return {
    personNationalTeamFileTypeState,
    arrayData: isPublicFileType ? arrayDataFiltered : arrayData
  };
};

export default useFileTypeDropdown;
            